module.exports = __webpack_public_path__ + "static/media/distribuicao-5.8eb098c8.jpg";